<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"/>
        <router-view name="floor"></router-view>
    </div>
</template>

<style>
    @import "~@assets/css/public/Reset.css";
</style>

<style lang="less">
    @import "~@assets/css/public/Global.less";
    @import "~@assets/css/public/VantCustom.less";

</style>
<script>
    // import 'assets/js/public/jquery-1.11.1.min'
    export default {
        // 解决安卓手机调出来软键盘，屏幕背景被挤压的问题
        created() {
            // 获取当前可视区域的高度
            const height = document.documentElement.clientHeight;
            // 在页面整体加载完毕时
            window.onload = function () {
                // 把获取到的高度赋值给根div
                document.getElementById('app').style.height = `${height}px`;
            };

        },

    };

</script>
